var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88727 19.3235C4.88727 19.8797 5.3382 20.3307 5.89445 20.3307H8.62686C9.10378 25.4601 13.1869 29.5432 18.3164 30.0202V32.7526C18.3164 33.3088 18.7673 33.7598 19.3235 33.7598C19.8798 33.7598 20.3307 33.3088 20.3307 32.7526V30.0202C25.4602 29.5432 29.5433 25.4601 30.0202 20.3307H32.7526C33.3089 20.3307 33.7598 19.8797 33.7598 19.3235C33.7598 18.7672 33.3089 18.3163 32.7526 18.3163H30.0202C29.5433 13.1868 25.4602 9.10372 20.3307 8.6268V5.89439C20.3307 5.33814 19.8798 4.88721 19.3235 4.88721C18.7673 4.88721 18.3164 5.33814 18.3164 5.89439V8.6268C13.1869 9.10372 9.10378 13.1868 8.62686 18.3163H5.89445C5.3382 18.3163 4.88727 18.7672 4.88727 19.3235ZM14.2876 19.3235C14.2876 16.5422 16.5423 14.2876 19.3235 14.2876C22.1048 14.2876 24.3595 16.5422 24.3595 19.3235C24.3595 22.1047 22.1048 24.3594 19.3235 24.3594C16.5423 24.3594 14.2876 22.1047 14.2876 19.3235Z",
    fill: "#858B9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 19.3235C16.302 17.6547 17.6548 16.3019 19.3235 16.3019C20.9923 16.3019 22.3451 17.6547 22.3451 19.3235C22.3451 20.9922 20.9923 22.345 19.3235 22.345C17.6548 22.345 16.302 20.9922 16.302 19.3235Z",
    fill: "#858B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeo);
export default __webpack_public_path__ + "static/media/icon-geo.dc57ddbe8b8569f7fce17d66bb3197d2.svg";
export { ForwardRef as ReactComponent };